import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'

const appMode = import.meta.env.VITE_APP_MODE;

async function bootstrap() {
  let App;

  if (appMode === 'resume') {
    // Resume-only mode — lightweight, no i18n, no Mantine, no heavy context
    const mod = await import('./ResumeApp');
    App = mod.default;
  } else if (appMode === 'reelfaith') {
    // ReelFaith mode — faith-based sermon clip app, bilingual en/fr
    const mod = await import('./ReelFaithApp');
    App = mod.default;
  } else if (appMode === 'aivideoeditor') {
    // AI Video Editor mode — separate deployment with EnhancedHome2 LP + PlansPage pricing
    await import('./i18n');
    const mod = await import('./AiVideoEditorApp');
    App = mod.default;
  } else {
    // Full app mode
    await import('./i18n'); // Initialize i18n only for full app
    const mod = await import('./App');
    App = mod.default;
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();
